export const GENERAL_ACTION = {
  SHOW_ERROR: "on_action_error",
  CLEAR_ERROR: "clear_action_error",
  UPDATE_HEADER_CONFIG: "update_header_config",
  SHOW_SUCCESS: "on_action_success",
  CLEAR_SUCCESS: "clear_action_success"
};



// WEBPACK FOOTER //
// ./src/modules/Layout/actions/types.js